import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import getConfig from 'next/config'
import { getCookiesValue } from 'helpers/cookie'
import { RTK_QUERY_OPTIONS } from './constants'

export const {
  publicRuntimeConfig: { baseURL },
} = getConfig()

export const api = createApi({
  reducerPath: 'api',
  keepUnusedDataFor: 60 * 60,
  ...RTK_QUERY_OPTIONS.ENABLE_REFETCH_ON_FOCUS,
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const accessToken = getCookiesValue('ac_token')
      const id = window?.Echo?.socketId?.()
      headers.set('Authorization', `Bearer ${accessToken}`)
      headers.set('accept', 'application/json')

      if (id) {
        headers.set('X-Socket-Id', id)
      }

      return headers
    },
  }),
  endpoints: () => ({}),
})
